import { render, staticRenderFns } from "./MangeGiftProgramTable.vue?vue&type=template&id=6de7c0a6&scoped=true"
import script from "./MangeGiftProgramTable.vue?vue&type=script&lang=js"
export * from "./MangeGiftProgramTable.vue?vue&type=script&lang=js"
import style0 from "./MangeGiftProgramTable.vue?vue&type=style&index=0&id=6de7c0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de7c0a6",
  null
  
)

export default component.exports